import { LAYOUT_MOUNTED, LAYOUT_UNMOUNTED } from './types'

export function doLayoutMounted() {
  return { type: LAYOUT_MOUNTED }
}
